/** @format */

import React, { useEffect, useState } from "react";
import UploadButton from "components/UploadButton";
import CategoryChips from "components/Chips";
import ReferenceImage from "components/ReferenceImages";
import GradientButton from "components/GradientButton";
import { GenerateIdeasProps } from "interfaces/payloads/GenerateIdeas";
import { useAppStore } from "store/useAppStore";
import { useNavigate } from "react-router-dom";
import Compressor from "compressorjs";
import { trackPromise } from "react-promise-tracker";
import HowItWorksModal from "components/HowItWorks";
import { handleDownload, handleShareFile } from "utils/helper";
import { dummyMaleImages, dummyFemaleImages } from "assets/data/DummyImageData";

import WebUI from "./WebUI";
interface Category {
  [key: string]: string[];
}

const UploadImage = () => {
  const upperGarmentImageUrl = useAppStore().upperGarmentImageUrl;
  const lowerGarmentImageUrl = useAppStore().lowerGarmentImageUrl;
  const setLowerGarmentImageUrl = useAppStore().setLowerGarmentImageUrl;
  const setUpperGarmentImageUrl = useAppStore().setUpperGarmentImageUrl;
  const setGenerateImageUrl = useAppStore().setGenerateImageUrl;
  const [activeGender, setActiveGender] = useState<any>(null);
  const [activeAgeCategory, setActiveAgeCategory] = useState<any>(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  //   const [maleImage, setMaleImages] = useState(dummyMaleImages);
  //   const [femaleImages, setFemaleImages] = useState(dummyFemaleImages);
  const generatedImageUrl = useAppStore()?.generatedImageUrl;
  const getRemainingCredits = useAppStore().getRemainingCredits;
  const availableCredits = useAppStore().credits;
  const generatedImage = useAppStore().generatedImage;
  const [enableButton, setEnableButton] = useState(true);

  useEffect(() => {
    if (generatedImageUrl) {
      setGenerateImageUrl();
    }
  }, []);

  useEffect(() => {
    setActiveGender("MALE");
  }, []);

  useEffect(() => {
    if (upperGarmentImageUrl && activeGender && selectedImageUrl) {
      setEnableButton(false);
    } else {
      setEnableButton(true);
    }
  }, [upperGarmentImageUrl, activeGender, selectedImageUrl]);

  console.log(selectedImageUrl, "selectedImageUrl");

  // useEffect(() => {
  //    getRemainingCredits().then((response: any) => {
  //       const currentCredit = response.data.remaining_credits;
  //       if (currentCredit > 0) {

  //       } else {
  //          navigate(`/purchase`);
  //       }
  //    });
  // }, [availableCredits]);

  const handleGenerateIdeas = async () => {
    var formData = new FormData();
    if (upperGarmentImageUrl.startsWith("data:")) {
      const fetchResponse = await fetch(upperGarmentImageUrl);
      const blob = await fetchResponse.blob();
      formData.append("upper_garment", blob, "image.jpg");
    } else {
      formData.append("upper_garment", upperGarmentImageUrl);
    }
    formData.append("model_url", selectedImageUrl);
    trackPromise(
      generatedImage(formData as unknown as GenerateIdeasProps).then(() => {
        if (window.innerWidth < 769) {
          window.location.href = "/saveimage";
        }
        //   setShowGenerateBtn(false);
      })
    );
  };

  const handleSelectedReferenceImage = (url: string) => {
    setSelectedImageUrl(url);
    if (generatedImageUrl) {
      setGenerateImageUrl();
    }
  };

  const handleUpperGarmentFileChange = (event: any) => {
    if (generatedImageUrl) {
      setGenerateImageUrl();
    }
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      new Compressor(file, {
        quality: 0.6,
        success(result: any) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result;
            setUpperGarmentImageUrl(base64String as string);
          };
          reader.readAsDataURL(result);
        },
        error(error: any) {
          console.log(error.message);
        },
      });
    }
  };

  const handleLowerGarmentFileChange = (event: any) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      new Compressor(file, {
        quality: 0.6,
        success(result: any) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result;
            setLowerGarmentImageUrl(base64String as string);
          };
          reader.readAsDataURL(result);
        },
        error(error: any) {
          console.log(error.message);
        },
      });
    }
  };

  const handleDownloadImage = () => {
    handleDownload(generatedImageUrl);
  };

  const handleShareFileImage = () => {
    handleShareFile(generatedImageUrl);
  };

  const handleGenderSelection = (gender: string) => {
    setActiveGender(gender);
    if (generatedImageUrl) {
      setGenerateImageUrl();
    }
  };

  const handleAgeSelection = (age: string) => {
    setActiveAgeCategory(age);
  };

  console.log(
    activeGender === "MALE" ? dummyMaleImages : dummyFemaleImages,
    activeGender,
    "activeGender"
  );

  return (
    <>
      {availableCredits > 0 && (
        <div className="max-md:hidden">
          <WebUI
            age={activeAgeCategory}
            gender={activeGender}
            handleUpperGarmentUpload={(event) =>
              handleUpperGarmentFileChange(event)
            }
            handleLowerGarmentUpload={(event) =>
              handleLowerGarmentFileChange(event)
            }
            handleSelectedImage={(url: string) =>
              handleSelectedReferenceImage(url)
            }
            selectedImageStyle={selectedImageUrl}
            selectedImageCategory={
              activeGender === "MALE" ? dummyMaleImages : dummyFemaleImages
            }
            setUpperGarmentImageUrl={setUpperGarmentImageUrl}
            setLowerGarmentImageUrl={setLowerGarmentImageUrl}
            onGenderSelect={(gender: string) => handleGenderSelection(gender)}
            onAgeSelect={(age: string) => handleAgeSelection(age)}
            generatedImage={generatedImageUrl}
            downloadImage={handleDownloadImage}
            shareImage={handleShareFileImage}
            enableButton={enableButton}
            onGenerateImage={handleGenerateIdeas}
          />
        </div>
      )}
    </>
  );
};

export default UploadImage;
